import { createUseStyles } from 'react-jss'

const rem = (px: number, base = 16): string =>
  `${Number((px / base).toFixed(4))}rem`

const useDriverStyle = createUseStyles({
  driver: {
    '& .driver-popover-prev-btn, .driver-popover-next-btn, .driver-popover-done-btn, #skipButton': {
      display: 'inline-block',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      userSelect: 'none',
      padding: `${rem(6)} ${rem(8)}`,
      border: `${rem(1)} solid transparent`,
      borderRadius: rem(4),
      fontSize: rem(13),
      position: 'relative',
      transition: 'box-shadow 200ms ease',
      textDecoration: 'none',
      lineHeight: 1,
      textColor: '#fff',
      color: '#fff',
      backgroundColor: '#bc31a2',
      borderColor: 'transparent',
      textShadow: 'none',

      '&:active, &:disabled, &:focus': {
        textColor: '#fff',
        color: '#fff',
        backgroundColor: '#bc31a2',
      },

      '&:hover': {
        textColor: '#fff',
        color: '#fff',
        backgroundColor: '#bc31a2',
        opacity: 0.5,
      },
    },
    '& input[type="checkbox"]': {
      accentColor: '#bc31a2',
      marginRight: rem(4),
    },
  },
})

export default useDriverStyle
